import $ from 'jquery';
const ScrollMagic = require('scrollmagic');
import screenSize from '../services/screen_size';
// require('../../../../../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js');
const controller = new ScrollMagic.Controller();
function addToController($ad, duration, offset, triggerHook) {
    if ($ad) {
        new ScrollMagic.Scene({
            triggerElement: $ad,
            duration: duration,
            offset: offset,
            triggerHook: triggerHook
        })
            .setPin($ad)
            .addTo(controller);
    }
}

function getSelector($domElement, $jQselector, domEl = true) {
    if (domEl) {
        if ($domElement) {
            return $domElement.find($jQselector)[0];
        }
        return $($jQselector).last()[0];
    }
    if ($domElement) {
        return $domElement.find($jQselector);
    }
    return $($jQselector).last();
}

export default ($selector) => {
    if (screenSize.getSize() !== 'small') {
        const $rightRailContainer = getSelector($selector, '.sticky-right-rail-container', false);
        const $sidebar = getSelector($selector, '.article-sidebar', false);
        // TODO: use a list for this
        const $firstAdWrapper = getSelector($selector, '.first-ad-wrap');
        const $secondAdWrapper = getSelector($selector, '.second-ad-wrap');
        const $thirdAdWrapper = getSelector($selector, '.third-ad-wrap');
        const $fourthAdWrapper = getSelector($selector, '.fourth-ad-wrap');
        const $fifthAdWrapper = getSelector($selector, '.fifth-ad-wrap');
        const $sixthAdWrapper = getSelector($selector, '.sixth-ad-wrap');
        const $seventhAdWrapper = getSelector($selector, '.seventh-ad-wrap');
        const $eighthAdWrapper = getSelector($selector, '.eighth-ad-wrap');
        const $ninthAdWrapper = getSelector($selector, '.ninth-ad-wrap');
        const $tenthAdWrapper = getSelector($selector, '.tenth-ad-wrap');
        const $eleventhAdWrapper = getSelector($selector, '.eleventh-ad-wrap');
        const $twelvethAdWrapper = getSelector($selector, '.twelveth-ad-wrap');

        // Adjust margin for slideshow posts, due to a set height being placed on the slideshow
        const $inlineSlideshowPosterDiv = $sidebar.parent().parent().find('header').last().find('.inline-slideshow');
        const $headerPosterWrapper = $sidebar.parent().parent().find('header').last().find('.poster-wrapper').not('.poster-wrapper__photo-gallery');
        // Sometimes slideshows have captions, when that happens, it throws off the height, so we need to adjust them
        function marginTopOnSlideshow() {
            let marginTop = '-436px';
            if ($inlineSlideshowPosterDiv.find('.slideshow-title').length) {
                marginTop = '-415px';
                if ($inlineSlideshowPosterDiv.find('.caption-list').length) {
                    marginTop = '-436pxx';
                }
            } else if ($inlineSlideshowPosterDiv.find('.slide-list-photogallery').length) {
                marginTop = '-436px';
            }
            return marginTop;
        }

        if ($inlineSlideshowPosterDiv.length) {
            $sidebar.css('margin-top', marginTopOnSlideshow);
        }

        // Adjust margin for article posts, due to a captions set below the header
        if ($headerPosterWrapper.length) {
            // Sometimes posters have captions, when that happens, it throws off the height, so we need to adjust them
            if ($headerPosterWrapper.find('.poster-caption').length) {
                $sidebar.css('margin-top', '-445px');
            }
        }

        if ($sidebar.parent().parent().find('header').last().find('.-no-art').length) {
            $sidebar.css('margin-top', '-40px');
        }
        // Sometimes the rail shows up before scrollmagic is init, and it creates that flicker effect, so we set sidebar to invis at start and display it via js this way
        $rightRailContainer.fadeIn();

        // If the article is short, we have to use a different duration than the default, otherwise the article page will be extended by the sidebar and thus creating white space at the bottom of article
        let articleContentHeight = $('.post-article').last().outerHeight();
        const sideRailCount = $('.post-article').last().parent().find('.side-rail-ad-wrap').length;

        if (articleContentHeight > 2500) {
            articleContentHeight -= 1000;
        } else {
            articleContentHeight -= 450;
        }

        // Adjust for when all rails are shown, and article happen to not be long enough, WEIRD
        // 3062996/world-changing-ideas/doppler-labs-and-the-quest-to-build-a-computer-for-your-ears
        if (sideRailCount >= 10) {
            articleContentHeight -= 3000;
        }

        // Sometimes articles have no body (watch), this will handle that
        if (articleContentHeight <= 0) {
            articleContentHeight = 10;
        }

        let duration = (articleContentHeight) / sideRailCount;
        // For custom post, we have a different sidebar with only one ad:
        // http://www.fastcompany.com/3056002/conquering-the-cloud/progress-by-the-numbers-technology-economics-in-a-digital-world?icid=np204ctc
        const lastCustomSidebarAdWrap = $('.custom-sidebar-ad-wrap').last();
        if (lastCustomSidebarAdWrap.length) {
            new ScrollMagic.Scene({
                triggerElement: lastCustomSidebarAdWrap[0],
                duration: articleContentHeight,
                offset: -50,
                triggerHook: .14
            })
                .setPin(lastCustomSidebarAdWrap[0])
                .addTo(controller);
        }

        // TODO: use a list for this
        // The values below have been carefully calibrated for our sidebar behavior
        addToController($firstAdWrapper, duration, 30, .14);
        addToController($secondAdWrapper, duration, 30, .14);
        addToController($thirdAdWrapper, duration, 30, .14);
        addToController($fourthAdWrapper, duration, 30, .2);
        addToController($fifthAdWrapper, duration, 30, .2);
        addToController($sixthAdWrapper, duration, 30, .2);
        addToController($seventhAdWrapper, duration, 30, .2);
        addToController($eighthAdWrapper, duration, 30, .2);
        addToController($ninthAdWrapper, duration, 30, .2);
        addToController($tenthAdWrapper, duration, 30, .2);
        addToController($eleventhAdWrapper, duration, 30, .2);
        addToController($twelvethAdWrapper, duration, 30, .2);
    }
};
